import React, { Component } from 'react';
import '../css/style.css';
import '../components/Home.css';
import PublicEventPagingLayout from './PublicEventPagingLayout';
import SearchLayout from './SearchLayout';
import { translate } from "react-i18next";
import {  Row, Col , Button} from 'react-bootstrap';
import { TEMPORARY } from '../backend/Backend';



class MyPublicEventsLayout extends Component {

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);

        this.state = {
            showPage: '0'
        }
    }

    handleChange(page) {
        this.setState({
            showPage: page
        });
    }


   render(){
      const { t } = this.props;

    const { params } = this.props.match
     return (<SearchLayout  eventKey="0" title={t("myPublicEvents")}>
        <div className="mt-3 ">
            <Row >
                    <Col>
                        <Button variant={this.state.showPage === '0' ? "primary" : "outline-primary"} onClick={() => this.handleChange("0")} className="float-left mt-3 ml-2">{t("Ereignisse")}</Button>
                        <Button variant={this.state.showPage === '1' ? "primary" : "outline-primary"} onClick={() => this.handleChange("1")} className="float-left mt-3 ml-2">{t("Nicht abgeschlossen")}</Button>
                        
                    </Col>
                </Row>
                {this.state.showPage === '0' ?
                    <div>
                        <Row className="mt-2 ml-2">
                            <Col >
                               {t("allMyCreatedPublicEvents")}
                            </Col>
                        </Row>
                        <Row className="mt-2 ">
                            <Col >
                               <PublicEventPagingLayout preURL="p-events/myEvents" id={params.id}  edit={true} />
                            </Col>
                        </Row>
                    </div>
                    : ''}
                 {this.state.showPage === '1' ?
                    <div>
                        <Row className="mt-3 ml-2">
                            <Col >
                            {t("allMyPublicNotFinished")}
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col >
                            <PublicEventPagingLayout preURL="p-events/userAndStatus" id={params.id}  edit={true}  eventStatus={TEMPORARY} />
                            </Col>
                        </Row>
                    </div>
                    : ''}

             
            </div>
    
 </SearchLayout>)
   }

}

export default translate("translations")(MyPublicEventsLayout);